export default __webpack_public_path__ + "static/media/logo-apple.2084a549.svg";